"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eddConfigFormSchema = exports.validateMinLessThanMax = exports.validateFixedDateMax = void 0;
const zod_1 = __importDefault(require("zod"));
const hooks_1 = require("@/edd/common/hooks");
/* eslint-disable camelcase */
const dateRangeSchema = zod_1.default.object({
    minDays: zod_1.default.preprocess((val) => {
        const num = Number(val);
        return isNaN(num) ? val : num;
    }, zod_1.default.number({ invalid_type_error: 'Minimum days must be a number' }).int('Minimum days must be a whole number').min(0, "Minimum days can't be negative")),
    maxDays: zod_1.default.preprocess((val) => {
        if (val === undefined || val === '') {
            return undefined;
        }
        const num = Number(val);
        return isNaN(num) ? val : num;
    }, zod_1.default.number({ invalid_type_error: 'Maximum days must be a number' }).int('Maximum days must be a whole number').min(0, "Maximum days can't be negative").optional()),
    fixedDate: zod_1.default.boolean()
});
function validateFixedDateMax(data, ctx) {
    if (!data.fixedDate && !data.maxDays) {
        ctx.addIssue({
            code: zod_1.default.ZodIssueCode.custom,
            message: "A number for maximum days is required if fixed date checkbox isn't used",
            path: ['minDays']
        });
    }
}
exports.validateFixedDateMax = validateFixedDateMax;
function validateMinLessThanMax(data, ctx) {
    if (!data.fixedDate && Number(data.minDays) > Number(data.maxDays)) {
        ctx.addIssue({
            code: zod_1.default.ZodIssueCode.custom,
            message: "Minimum days can't be greater than maximum days",
            path: ['minDays']
        });
    }
}
exports.validateMinLessThanMax = validateMinLessThanMax;
const daySchema = zod_1.default
    .object({
    enabled: zod_1.default.boolean(),
    cutoffTime: zod_1.default.string().nullable().optional()
})
    .superRefine((data, ctx) => {
    if (data.enabled && (!data.cutoffTime || data.cutoffTime.length !== 5)) {
        ctx.addIssue({
            code: zod_1.default.ZodIssueCode.custom,
            message: 'Please provide hours, minutes, and AM / PM for cutoff time',
            path: ['cutoffTime']
        });
    }
});
const daysOfWeekSchema = zod_1.default.object(Object.fromEntries(hooks_1.DAYS_OF_WEEK.map((day) => [day, daySchema])));
const orderFulfillmentConfigSchema = zod_1.default
    .object(Object.assign(Object.assign({ timeZone: zod_1.default.string() }, daysOfWeekSchema.shape), dateRangeSchema.shape))
    .superRefine(validateFixedDateMax)
    .superRefine(validateMinLessThanMax);
exports.eddConfigFormSchema = zod_1.default.object({
    template: zod_1.default.string(),
    orderFulfillmentConfig: orderFulfillmentConfigSchema
});
